import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import LoadingViewerTop from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/ViewerTop/LoadingViewerTop/LoadingViewerTop";
import TaskViewerHeader from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/ViewerTop/TaskViewerHeader/TaskViewerHeader";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";
import { memo, ReactNode } from "react";

interface TaskViewerSheetHeaderProps {
  isNotFound: boolean; // Either taskType or task is not found
  isLoading: boolean; // Either loading taskType or task
  task: Record<string, unknown> | Loading;
  viewerTopFragment: ReactNode;
  recurrenceText: string | null;
  onCloseClick: () => void;
  onTopMenuButtonClick?: () => void;
}

export const TaskViewerSheetHeader = memo(
  (props: TaskViewerSheetHeaderProps) => {
    const {
      isNotFound,
      isLoading,
      task,
      viewerTopFragment,
      recurrenceText,
      onCloseClick,
      onTopMenuButtonClick,
    } = props;
    if (isNotFound) {
      return (
        <FixaModalHeader
          data-testid="viewer-sheet-header-not-found"
          closeBtnClick={onCloseClick}
        />
      );
    } else if (isLoading) {
      return (
        <LoadingViewerTop
          testId="viewer-sheet-header-loading"
          onCloseButtonClick={onCloseClick}
        />
      );
    } else {
      return (
        <TaskViewerHeader
          testId="viewer-sheet-header-loaded"
          task={task}
          onCloseButtonClick={onCloseClick}
          onMenuButtonClick={onTopMenuButtonClick}
          topFragment={viewerTopFragment}
          recurrenceText={recurrenceText}
        />
      );
    }
  }
);
